export enum StairBlockType {
  RUN = "RUN",
  LANDING = "LANDING",
}
export enum SurfaceType {
  TREAD = "TREAD",
  LANDING_FROM_TREAD = "LANDING_FROM_TREAD",
  LANDING = "LANDING",
}

export enum EdgeType {
  RIGHT = "RIGHT",
  LEFT = "LEFT",
  FRONT = "FRONT",
  BACK = "BACK",
}
export enum StairHorizontalAlignment {
  RIGHT = "RIGHT",
  CENTER = "CENTER",
  LEFT = "LEFT",
}

export enum StairVerticalAlignment {
  TOP = "TOP",
  BOTTOM = "BOTTOM",
}

export enum StairLateralAlignment {
  /**
   * Outside Face
   */
  OF = "OF",
}
export type StairBlockHostType = "EDGE" | "DATUM";

export type StairBlockRunHostingEdgeType = "UPPER" | "LOWER" | "OTHER";
export enum StairErrors {
  HOST_NOT_FOUND = "Host not found when resolving stairs",
  DATUM_NOT_FOUND = "Datum not found when resolving stairs",
}
/**
 * The planes of a generated stair run:
 * ```
 *                    +--------+ - - - - - - +
 *                    |        | <- BACK     : <- BACK (if landing)
 *           +--------+     .-'- - - - - - - +
 *           |          .-'          ^ LANDING
 *  +--------+      .-'
 *  |          .-'    ^ UNDERSIDE
 *  +--------'
 *     ^
 *    BOTTOM
 *
 * ```
 */

export enum StairPlanes {
  LANDING = "LANDING",
  UNDERSIDE = "UNDERSIDE",
  STRINGER = "STRINGER",
  BOTTOM = "BOTTOM",
  BACK = "BACK",
}
